/**
 * BESTIX v5.0 — VIP Section
 * Premium packages showcase
 */

import { Crown } from 'lucide-react';
import { VIPPackageCard, type VIPPackageProps } from './VIPPackageCard';
import { cn } from '@/lib/utils';

interface VIPSectionProps {
  packages: VIPPackageProps[];
  title?: string;
  subtitle?: string;
  className?: string;
}

export function VIPSection({
  packages,
  title = "VIP Experiences",
  subtitle = "Elevate your event with premium packages",
  className,
}: VIPSectionProps) {
  if (packages.length === 0) return null;

  return (
    <section className={cn('py-16 px-6', className)}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 text-[var(--color-gold)] mb-4">
            <Crown className="w-6 h-6" />
            <span className="text-sm font-medium uppercase tracking-wide">Premium</span>
          </div>
          <h2 className="font-playfair italic text-3xl md:text-4xl text-[var(--color-navy)] mb-2">
            {title}
          </h2>
          <p className="text-gray-500 text-lg">{subtitle}</p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {packages.map((pkg) => (
            <VIPPackageCard key={pkg.id} {...pkg} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default VIPSection;
